import { useState } from 'react';
import { Row, Col, Badge, Button } from 'react-bootstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Paginate from '../components/Paginate';
import Loader from '../components/Loader';
import Message from '../components/Message';
import BlogCard from '../components/BlogCard';
import BackToTop from '../components/BackToTop';

import { useGetBlogPostsQuery } from '../slices/blogsApiSlice';

export default function BlogListScreen() {
  const [activeTag, setActiveTag] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(
    Number(localStorage.getItem('blogPerPage')) || 10
  );

  const { pageNumber } = useParams();
  const page = Number(pageNumber) || 1;
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const basePath = '/blog';

  const { data, isLoading, error } = useGetBlogPostsQuery({
    page,
    pageSize: itemsPerPage,
    tag: activeTag || undefined,
  });

  if (isLoading) return <Loader />;

  if (error) {
    return (
      <Message variant='danger'>
        {error?.data?.message || error.error}
      </Message>
    );
  }

  const handleItemsPerPageChange = (e) => {
    const value = Number(e.target.value);
    setItemsPerPage(value);
    localStorage.setItem('blogPerPage', value);
    if (page !== 1) navigate(basePath);
  };

  const handleTagClick = (tag) => {
    setActiveTag(activeTag === tag ? null : tag);
    if (page !== 1) navigate(basePath);
  };

  return (
    <>
      <div className='d-flex justify-content-between align-items-center' style={{ marginTop: '32px' }}>
        <h1 className='mb-0'>Blog</h1>
        {userInfo && (
          <Link to={`/me/blogs/new`}>
            <Button variant='primary'>New Post</Button>
          </Link>
        )}
      </div>

      {data.allTags && data.allTags.length > 0 && (
        <div className='d-flex flex-wrap gap-2 my-3'>
          {data.allTags.map((tag) => (
            <Badge
              key={tag}
              bg={activeTag === tag ? 'primary' : 'secondary'}
              style={{ cursor: 'pointer' }}
              onClick={() => handleTagClick(tag)}
            >
              {tag}
            </Badge>
          ))}
          {activeTag && (
            <Badge
              bg='outline-secondary'
              text='dark'
              style={{ cursor: 'pointer', border: '1px solid #6c757d' }}
              onClick={() => setActiveTag(null)}
            >
              ✕ Clear
            </Badge>
          )}
        </div>
      )}

      <div className='d-flex flex-wrap gap-4 mb-4'>
        <div className='d-flex align-items-center'>
          <span className='me-2 fw-bold'>Posts per Page:</span>
          <select value={itemsPerPage} onChange={handleItemsPerPageChange} className='form-select form-select--custom w-auto'>
            <option className='option--custom' value='5'>5</option>
            <option className='option--custom' value='10'>10</option>
            <option className='option--custom' value='15'>15</option>
            <option className='option--custom' value='20'>20</option>
          </select>
        </div>
      </div>

      {data.posts.length === 0 ? (
        <Message>No blog posts found.</Message>
      ) : (
        <Row>
          {data.posts.map((post) => (
            <Col key={post._id} sm={12} md={12} lg={12} xl={12}>
              <BlogCard post={post} />
            </Col>
          ))}
        </Row>
      )}

      <div className='d-flex justify-content-center' style={{ margin: '32px 0' }}>
        <Paginate
          totalPages={data?.totalPages}
          currentPage={data?.currentPage}
          basePath={basePath}
          firstPageIsBasePath={true}
        />
      </div>
      <BackToTop heroThreshold={200} />
    </>
  );
}
